'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseIcon = function (_Component) {
  (0, _inherits3.default)(BaseIcon, _Component);

  function BaseIcon() {
    (0, _classCallCheck3.default)(this, BaseIcon);
    return (0, _possibleConstructorReturn3.default)(this, (BaseIcon.__proto__ || (0, _getPrototypeOf2.default)(BaseIcon)).apply(this, arguments));
  }

  (0, _createClass3.default)(BaseIcon, [{
    key: 'getStrokeColor',
    value: function getStrokeColor() {
      return this.props.color === 'inherit' ? BaseIcon.defaultProps.color : this.props.color;
    }
  }, {
    key: 'getSvgProps',
    value: function getSvgProps() {
      var _props = this.props,
          height = _props.height,
          width = _props.width,
          style = _props.style,
          viewBox = _props.viewBox;


      if (this.props.raw) {
        return {
          width: width,
          height: height,
          style: style,
          viewBox: viewBox
        };
      }

      return {
        style: style,
        viewBox: viewBox
      };
    }
  }, {
    key: 'getPathProps',
    value: function getPathProps() {
      var _props2 = this.props,
          fillRule = _props2.fillRule,
          color = _props2.color;

      return {
        fillRule: fillRule,
        fill: color
      };
    }
  }]);
  return BaseIcon;
}(_react.Component);

BaseIcon.huiName = 'BaseIcon';
BaseIcon.propTypes = {
  color: _propTypes2.default.string,
  fillRule: _propTypes2.default.string,
  height: _propTypes2.default.number,
  raw: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  viewBox: _propTypes2.default.string,
  width: _propTypes2.default.number
};
BaseIcon.defaultProps = {
  color: '#000', // color is used for fill and stroke properties
  fillRule: 'evenodd',
  height: null,
  raw: false,
  style: {},
  viewBox: null,
  width: null
};
exports.default = BaseIcon;
//# sourceMappingURL=BaseIcon.js.map


//////////////////
// WEBPACK FOOTER
// ../icon/lib/Icons/BaseIcon.js
// module id = 9
// module chunks = 0